import * as Turbo from '@hotwired/turbo'
Turbo.start()

import "./style.css"
import "~/controllers"

// Set timezone cookie
const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
document.cookie = `timezone=${timezone}; path=/; max-age=31536000`